<template>
  <pt-health-record-detail class="pt-health-record-detail__page" :id="id"></pt-health-record-detail>
</template>

<script>
import PtHealthRecordDetail from 'cps/customer-manage/pt-customer-detail/pt-health-record-detail/withData'
export default {
  name: 'pt-health-record-detail__view',
  components: {
    'pt-health-record-detail': PtHealthRecordDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
